// Authentication utility functions

export const login = async (email, password) => {
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Login failed');
  }

  // Store token in localStorage as backup
  if (data.token) {
    localStorage.setItem('adminToken', data.token);
  }

  return data;
};

export const signup = async (email, password, name, signupKey) => {
  const response = await fetch('/api/auth/signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password, name, signupKey }),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Signup failed');
  }

  // Store token in localStorage as backup
  if (data.token) {
    localStorage.setItem('adminToken', data.token);
  }

  return data;
};

export const logout = async () => {
  await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include'
  });

  localStorage.removeItem('adminToken');
};

export const getCurrentAdmin = async () => {
  const token = localStorage.getItem('adminToken');

  const response = await fetch('/api/auth/me', {
    headers: token ? {
      'Authorization': `Bearer ${token}`
    } : {},
    credentials: 'include'
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return data.admin;
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? {
    'Authorization': `Bearer ${token}`
  } : {};
};
